import axios from 'axios'

const DelayedAnimation = require('./components/delayedAnimation.js')
const Dropdown = require('./components/dropdown.js')
const FinalStep = require('./components/finalStep.js')
const DedicationModal = require('./components/dedicationModal.js')
const LanguageModal = require('./components/languageModal.js')
const BookFormat = require('./components/bookFormat.js')
const clickOutside = require('./components/clickOutside.js')
const transitonExpand = require('./components/transitonExpand.js')
const carousel = require('./components/carousel.js')
const memberCarousel = require('./components/memberCarousel.js')
const languageDropdown = require('./components/languageDropdown.js')
const notification = require('./components/notification.js')
const loading = require('./components/loading.js')
const bookPreview = require('./components/bookPreview.js')
const bookPreviewMobile = require('./components/bookPreviewMobile.js')
const bookPreviewModal = require('./components/bookPreviewModal.js')
const accessoryTypeItem = require('./components/accessoryTypeItem.js')
const checkbox = require('./components/checkbox.js')

Vue.component("DelayedAnimation", DelayedAnimation);
Vue.component("Dropdown", Dropdown);
Vue.component("FinalStep", FinalStep);
Vue.component("DedicationModal", DedicationModal);
Vue.component("LanguageModal", LanguageModal);
Vue.component("BookFormat", BookFormat);
Vue.component("clickOutside", clickOutside);
Vue.component("transitonExpand", transitonExpand);
Vue.component("carousel", carousel);
Vue.component("memberCarousel", memberCarousel);
Vue.component("languageDropdown", languageDropdown);
Vue.component("notification", notification);
Vue.component("loading", loading);
Vue.component("bookPreview", bookPreview);
Vue.component("bookPreviewMobile", bookPreviewMobile);
Vue.component("bookPreviewModal", bookPreviewModal);
Vue.component("accessoryTypeItem", accessoryTypeItem);
Vue.component("checkbox", checkbox);

const app = document.querySelector('#app')

const token = $('meta[name="csrf-token"]').attr('content')

if (app) new Vue({
  el: '#app',

  data () {
    return {
      data: null,
      order: null,
      mOrder: null,
      fOrder: null,
      name: localStorage.getItem('name') || '',
      sex: localStorage.getItem('sex') || 'M',
      step: localStorage.getItem('step') || 'one',
      activeState: 'skin',
      members: null,
      bookFormats: null,
      skinColors: null,
      hairColors: null,
      loading: false,
      editData: false,
      oldHairType: null,
      oldHairColor: null,
      isShowTooltip: false,
      translation: null,
      lang: null,
      isOpenNotification: false,
      errorMessage: '',
      needUpdate: false,
      languages: [],
      images: []
    }
  },

  computed: {
    imageGirl () {
      return (this.step === 'one' || this.step === 'two') && this.fOrder
        ? `https://elasticbeanstalk-ca-central-1-793914884489.s3.ca-central-1.amazonaws.com/assets/character_creator/No Jersey/${this.fOrder.skinColor.code}${this.order.accessory.code}F${this.fOrder.hairType.code.split('')[1]}${this.fOrder.hairColor.code}.png`
        : `https://elasticbeanstalk-ca-central-1-793914884489.s3.ca-central-1.amazonaws.com/assets/character_creator/No Jersey/${this.order.skinColor.code}${this.order.accessory.code}F${this.order.hairType.code.split('')[1]}${this.order.hairColor.code}.png`
    },

    imageBoy () {
      return (this.step === 'one' || this.step === 'two') && this.mOrder
        ? `https://elasticbeanstalk-ca-central-1-793914884489.s3.ca-central-1.amazonaws.com/assets/character_creator/No Jersey/${this.mOrder.skinColor.code}${this.order.accessory.code}M${this.mOrder.hairType.code.split('')[1]}${this.mOrder.hairColor.code}.png`
        : `https://elasticbeanstalk-ca-central-1-793914884489.s3.ca-central-1.amazonaws.com/assets/character_creator/No Jersey/${this.order.skinColor.code}${this.order.accessory.code}M${this.order.hairType.code.split('')[1]}${this.order.hairColor.code}.png`
    },

    characterImage () {
      return `https://elasticbeanstalk-ca-central-1-793914884489.s3.ca-central-1.amazonaws.com/assets/character_creator/${this.order.member.team_name}/${this.order.skinColor.code}${this.order.accessory.code}${this.order.hairType.code}${this.order.hairColor.code}.png`
    },

    hairTypes () {
      const matchArr = this.data.codes.hairType.filter(item => {
        return item.code.match(this.sex)
      })
      return matchArr
    },

    accessoryTypes () {
      if (this.sex === "F") {
        return this.data.codes.accessory.filter(item => item.code !== 'A2')
      } else {
        return this.data.codes.accessory.filter(item => item.code !== 'A1')
      }
    },

    isBald () {
      return this.order.hairType.code.split('')[1] === '0'
    },

    isEdit () {
      return !!window.location.pathname.match('edit-book')
    }
  },

  created () {
    this.lang = document.getElementsByTagName('head')[0].getAttribute('lang');
    this.editData = window.order
    this.loading = true

    if (this.isEdit) {
      this.step = 'final'
      this.images = window.order.images
    } else if (this.editData) {
      this.step = 'six'
    }

    if (window.location.search !== '' && window.location.search.match('step')) {
      const query = window.location.search.split('&')
      this.step = query[1].split('=')[1]
    }

    axios.get(`/${this.lang}/get-constructor/`).then(res => {
      this.init(res.data)
      this.loading = false
      this.translation = res.data.translation
      this.languages = res.data.languages

      const softcover = res.data.book_formats.find(item => item.id === 1)
      document.getElementById('price').innerHTML = softcover.price
    }).catch(err => { this.loading = false })

    const heroBlock = document.querySelector('#hero-block')
    if (heroBlock) heroBlock.classList.remove('hero__hidden')
    if (window.location.search.match('get-started')) heroBlock.scrollIntoView({ behavior: 'smooth', block: 'start' })
  },

  mounted () {
    // this.changePreview()
    // this.changePreviewName()
    if (! localStorage.getItem('selectedLanguage')){
      localStorage.setItem('selectedLanguage', true)
      this.openLanguageModal();
    }
  },

  methods: {
    init (data) {
      this.data = data

      if (this.editData) {
        this.initEditData(data)
      } else {
        this.initDefaultData(data)
      }

      this.hairColors = data.codes.hairColor
      this.skinColors = data.codes.skinColor
      this.bookFormats = data.book_formats
      this.members = data.members
    },

    initDefaultData (data) {
      this.setDefaultCharacter(data)

      this.order = JSON.parse(localStorage.getItem('order')) || {
        name: this.name,
        skinColor: data.codes.skinColor[0],
        hairColor: data.codes.hairColor[1],
        hairType: data.codes.hairType[1],
        accessory: data.codes.accessory[0],
        bookFormat: { title: 'Book Format' },
        dedication: '',
        member: data.members[0],
        language: null
      }
    },

    initEditData (data) {
      this.sex = this.getInitSex(this.editData.hair_type)
      const bookFormat = data.book_formats.find(item => item.id === this.editData.book_format.id)
      this.name = this.editData.name

      this.setDefaultCharacter(data)

      this.order = {
        name: this.editData.name,
        skinColor: this.editData.skin,
        hairColor: this.editData.hair,
        hairType: this.editData.hair_type,
        accessory: this.editData.accessory,
        bookFormat: bookFormat,
        dedication: this.editData.dedication,
        member: this.editData.team_member,
        language: this.editData.language
      }
    },

    setDefaultCharacter (data) {
      const fSkinColor = data.codes.skinColor.find(item => item.code === 'S.5')
      const fHairType = data.codes.hairType.find(item => item.code === 'F5')
      const fHairColor = data.codes.hairColor.find(item => item.code === '_10')

      const mSkinColor = data.codes.skinColor.find(item => item.code === 'S.1')
      const mHairType = data.codes.hairType.find(item => item.code === 'M2')
      const mHairColor = data.codes.hairColor.find(item => item.code === '_1')

      this.fOrder = {
        name: this.name,
        skinColor: fSkinColor || data.codes.skinColor[0],
        hairColor: fHairColor || data.codes.hairColor[1],
        hairType: fHairType || data.codes.hairType[1]
      }

      this.mOrder = {
        name: this.name,
        skinColor: mSkinColor || data.codes.skinColor[0],
        hairColor: mHairColor || data.codes.hairColor[1],
        hairType: mHairType || data.codes.hairType[1]
      }
    },

    getInitSex (value) {
      return value.code.split('')[0]
    },

    saveOrder () {
      this.needUpdate = true
      if(!this.editData) localStorage.setItem('order', JSON.stringify(this.order))
    },

    changeGender (value) {
      const currentHairType = this.order.hairType.code.split('')
      currentHairType[0] = value
      this.order.hairType = this.data.codes.hairType.find(item => item.code === currentHairType.join(''))

      this.sex = value
      localStorage.setItem('sex', value)
      this.saveOrder()
      // this.changePreview()
      // this.changePreviewName()
    },

    changeState (value) {
      this.activeState = value
      if(!this.editData) localStorage.setItem('activeState', value)
    },

    changeSkinColor (item) {
      this.order.skinColor = item
      this.saveOrder()
    },

    changeAccessory (item) {
      if (item.code === this.order.accessory.code) return // disable multiple clicking

      if (item.code === 'A1' || item.code === 'A2') return
      // if (item.code === 'A1' || item.code === 'A2') {
      //   // save old hair type and hair color codes
      //   this.oldHairType = this.order.hairType
      //   this.oldHairColor = this.order.hairColor
      //   // set hair type and color codes to 0
      //   this.order.hairType = this.data.codes.hairType.find(item => item.code === `${this.sex}0`)
      //   this.order.hairColor = this.data.codes.hairColor[0]
      // } else {
      //   if (this.oldHairType && this.oldHairColor) {
      //     // Replace hair type and color with old
      //     this.order.hairType = this.oldHairType
      //     this.order.hairColor = this.oldHairColor
      //     this.oldHairType = null
      //     this.oldHairColor = null
      //   }
      // }

      this.order.accessory = item
      this.saveOrder()
    },

    changeHairType (item) {
      if (item.code.split('')[1] === '0') {
        const baldCode = this.data.codes.hairColor.find(item => item.code === '_0')
        this.order.hairColor = baldCode
      } else if (this.order.hairColor.code === '_0') {
        const firstColor = this.data.codes.hairColor.find(item => item.code === '_1')
        this.order.hairColor = firstColor
      }

      this.order.hairType = item
      this.saveOrder()
    },

    changeHairColor (item) {
      if (this.isBald)  return

      this.order.hairColor = item
      this.saveOrder()
    },

    changeCurrency (currencyId) {
      $.ajax({
        url: "{% url 'change_currency' %}",
        method: "POST",
        data:
          {
              currencyId: currencyId,
              csrfmiddlewaretoken: '{{ csrf_token }}'
          },
        datatype: "json"
      }).done(function (data) {
        if (data.success) {
            location.reload();
        }
      });
    },

    showTooltip (index) {
      this.isShowTooltip = index === 1
    },

    hideTooltip () {
      this.isShowTooltip = false
    },

    resetCharacter () {
      const character = this.order
      const hairType = this.data.codes.hairType.find(item => item.code === [this.sex, 1].join(''))

      character.skinColor = this.data.codes.skinColor[0]
      character.hairColor = this.data.codes.hairColor[1]
      character.hairType = hairType
      character.accessory = this.data.codes.accessory[0]

      this.order = character
      this.changeState('skin')
    },

    toStep (step) {
      if (step === 'two') {
        this.resetCharacter()
      }

      this.step = step

      const el = document.getElementById('hero-block')
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })

      if(!this.editData) {
        localStorage.setItem('step', step)
        localStorage.setItem('activeState', this.activeState)
        this.saveOrder()
      }
    },

    setMember (item) {
      this.order.member = item
      this.saveOrder()
    },

    setLanguage (value) {
      this.order.language = value
    },

    changePreview () {
      const previewCharacter = document.getElementById('how-it-works__character')
      const previewHero = document.getElementById('how-it-works__hero')
      const previewSummary = document.getElementById('how-it-works__summary')

      previewCharacter.src = `/static/personal_book_app/img/how-it-works/${this.sex}-character.png`
      previewHero.src = `/static/personal_book_app/img/how-it-works/${this.sex}-hero.png`
      previewSummary.style = `background-image: url(/static/personal_book_app/img/how-it-works/${this.sex}-summary.png)`
    },

    changePreviewName () {
      const previewName = document.getElementById('how-it-works__name')

      const name = this.order && this.order.name ? this.order.name : this.sex === 'F' ? 'Emily' : 'Chris'

      previewName.value = name
    },

    openBookFormatModal () {
      this.$refs.bookFormat.open()
    },

    openDedicationModal () {
      this.$refs.dedication.open()
    },

    openLanguageModal () {
      this.$refs.language.open()
    },

    lastStepClick () {
      if (this.editData) {
        if (this.needUpdate) {
          this.addToCart({}).then(_ => {
            window.location.href = `/edit-book/${this.editData.uuid}`
          })
        } else {
          window.location.href = `/edit-book/${this.editData.uuid}`
        }

        return
      }
      this.openDedicationModal()
    },
    addToCart ({ cb = null, updateBookFormat = false, updateDedication = false}) {
      this.loading = true

      const bodyFormData = new FormData()

      bodyFormData.set("hair", this.order.hairColor.id),
      bodyFormData.set("hair_type", this.order.hairType.id),
      bodyFormData.set("skin", this.order.skinColor.id),
      bodyFormData.set("accessory", this.order.accessory.id),
      bodyFormData.set("team_member", this.order.member.id),
      bodyFormData.set("name", this.order.name),
      bodyFormData.set("dedication", this.order.dedication.trim()),
      bodyFormData.set("book_format", this.order.bookFormat.id)
      bodyFormData.set("update_book_format", updateBookFormat)
      bodyFormData.set("update_dedicationt", updateDedication)
      bodyFormData.set("language", this.order.language)
      if (this.editData && this.editData.uuid) bodyFormData.set("order_item_uuid", this.editData.uuid)

      return axios.post('/add-to-cart/', bodyFormData, { headers: {'X-CSRFToken': token, 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          if(res.data.success) {
            localStorage.clear()
            localStorage.setItem('selectedLanguage', true)

            if (this.isEdit) {
              this.loading = false
              cb()
            } else {
              window.location.href = `/edit-book/${res.data.uuid}`
            }
          } else {
            this.loading = false
            this.isOpenNotification = true
            this.errorMessage = res.data.errors
          }
        }).catch(err => {
          this.loading = false
          this.isOpenNotification = true
          this.errorMessage = err
        })
    }
  },
  watch: {
    name (value) {
      this.order.name = value
      localStorage.setItem('name', value)
    },

    step (newStep, oldStep) {
      if (newStep === 'three' && oldStep === 'two') {
        if (this.sex === 'M') {
          this.order.hairType = this.mOrder.hairType
          this.order.hairColor = this.mOrder.hairColor
          this.order.skinColor = this.mOrder.skinColor
        } else {
          this.order.hairType = this.fOrder.hairType
          this.order.hairColor = this.fOrder.hairColor
          this.order.skinColor = this.fOrder.skinColor
        }

        this.order.name = this.name
      }
    }
  }
})
